import useDataFetcher from '~/components/useDataFetcher';
import type { ClaimFlagConfigurationsResponse } from '~/server_shared/openapi/data-contracts';

import type { ClaimFlagConfiguration, UseFetchClaimFlagConfigurationsReturnType } from '../types';

// Stable reference for the empty case so consumers doing render-phase state syncs don't loop.
const EMPTY_CONFIGURATIONS: ClaimFlagConfiguration[] = [];

const useFetchClaimFlagConfigurations = ({
  organizationId,
  shouldFetch = true,
}: {
  organizationId: number;
  shouldFetch?: boolean;
}): UseFetchClaimFlagConfigurationsReturnType => {
  const { data, isLoading, isError, reloadData } = useDataFetcher<ClaimFlagConfigurationsResponse>(
    `/api/v1/organizations/${organizationId}/claim_flag/config`,
    null,
    shouldFetch
  );

  return {
    claimFlagConfigurations: data?.flag_configurations ?? EMPTY_CONFIGURATIONS,
    isLoading,
    isError,
    reloadData,
  };
};

export default useFetchClaimFlagConfigurations;
